<template>
    <div id="app">
        <Login></Login>
        <WarningBar></WarningBar>
        <transition name="scroll_bar_transition">
            <ScrollBar v-show="show_index_scroll_bar"
                       :class="[route_name != 'Home' ? 'app_scroll_bar' : '',
                            route_name != 'Home' && route_name != 'course' && scrolled ? 'app_scroll_bar_scrolled' : '']"
            >
            </ScrollBar>
        </transition>
        <div class="main-container">
            <transition name="tab_router_view">
                <keep-alive :include="cache_router">
                    <router-view></router-view>
                </keep-alive>
            </transition>
        </div>
        <Footer v-show="show_index_footer"></Footer>
    </div>
</template>

<script>
    import Footer from '@/components/common_components/footer/footer.vue'
    import ScrollBar from '@/components/common_components/scroll_bar/scroll_bar.vue'
    import Login from '@/components/common_components/sign_on_up/login.vue'
    import WarningBar from '@/components/common_components/warning_bar/warning_bar.vue'

    import {mapState, mapActions} from 'vuex'
    import cookies from "vue-cookies";


    export default {
        name: 'App',
        components: {
            Footer,
            ScrollBar,
            Login,
            WarningBar
        },
        data: function () {
            return {
                cache_router: ['Home', 'path', 'library', 'login', 'notfound']
            }
        },
        methods: {
            ...mapActions({
                moniting_scrollbar: 'scrollBar/update_scroll_value',
                get_user_info: 'loginState/change_user_info',
                log_out: 'loginState/log_out',
                get_studied_courses: 'loggedInfo/change_user_studied_courses',
                sso_user_login: 'loginState/sso_user_login',
            })
        },

        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                login_user: state => state.loginState.user_info,
                scrolled: state => state.scrollBar.current_scrolled_value > 100,
                show_index_scroll_bar: function (state) {
                    var invisible_scroll_bar_routes = ['learning', 'playback','mobileplan','newmobileplan','planmobileinfo','mobiletodo','editmobileplan','planmobilenotes']
                    if (!this.$route.name || invisible_scroll_bar_routes.includes(this.$route.name)) {
                        return false
                    }
                    var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                    if (flag && (this.$route.name === 'test_socket' || this.$route.name === 'course')){
                        return false
                    }
                    if (this.$route.name == 'Home') {
                        return state.scrollBar.show_scroll_bar
                    } else {
                        return true
                    }
                }
            }),
            show_index_footer: function () {
                var invisible_footer_routes = ['publish', 'post_publish', 'post_edit', 'learning', 'playback', 'password_find','pay-success','pay-fail', 'test_socket','mobileplan','newmobileplan','planmobileinfo','mobiletodo','editmobileplan','planmobilenotes']
                var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                if (flag && this.$route.name === 'course'){
                        return false
                }
                if (!this.$route.name || invisible_footer_routes.includes(this.$route.name)) {
                    return false
                } else {
                    return true
                }
            },
            route_name: function () {
                console.log(this.$route.name)
                return this.$route.name
            }
        },
        watch: {
            login_user() {
                if (!this.login_user.id) {
                    // 登录失效退出登录
                    this.log_out()
                }
            },
        },
        mounted() {
            if (this.sign_on) {
                this.get_user_info()
                this.get_studied_courses()
            }
            else{
                var reg = new RegExp("(^|&)token=([^&]*)(&|$)", "i");
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    var token = unescape(r[2]);
                    this.sso_user_login({'token': token});
                }

            }
            window.addEventListener('scroll', this.utils.throttle(this.moniting_scrollbar, 90))

        }
    }
</script>

<style>
    html {
        scroll-behavior: smooth;
    }

    body {
        border: 0;
        height: 100%;
        /*background: #f9f9f9;*/
        font-size: 13px;
        line-height: 1.4285;
        font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;
    }

    * {
        margin: 0;
        padding: 0;
    }

    img {
        height: 100%;
        border: 0;
        vertical-align: middle;
        transition: all .3s ease-in-out;
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    a {
        text-decoration: none !important;
    }

    #app {
        /*height: calc(100vh - 263px);*/
    }

    .tab_router_view-enter-active, .tab_router_view-leave_active {
        /*opacity: 0;*/
        transition: all .5s;
    }

    .tab_router_view-enter, .tab_router_view-leave-to {
        opacity: 0;
    }

    .tab_router_view-enter-to, .tab_router_view-leave {
        opacity: 1;
    }

    .scroll_bar {
        position: fixed;
    }

    /* 滚动条的过渡设置 */
    .scroll_bar_transition-enter-active, .scroll_bar_transition-leave-active {
        transition: opacity 0.3s;
    }

    .scroll_bar_transition-enter {
        opacity: 0;
    }

    .scroll_bar_transition_enter-to {
        opacity: 1;
    }

    .scroll_bar_transition-leave {
        opacity: 1;
    }

    .scroll_bar_transition-leave-to {
        opacity: 0;
    }

    .app_scroll_bar {
        position: relative;
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, .18);
        margin-bottom: 20px;
    }

    .app_scroll_bar_scrolled {
        position: fixed;
    }

    .app_scroll_bar_scrolled + div {
        margin-top: 92px;
    }

    .main-container {
        min-height: 300px;
    }

    .margin-right-10 {
        margin-right: 10px;
    }

    .margin-top-10 {
        margin-top: 10px;
    }

    .full-page {
        margin-top: -20px;
    }

    .o_image {
        display: inline-block;
        width: 48px;
        height: 48px;
        background-image: url('/static/mimetypes/unknown.svg');
        background-size: contain;
    }

    .o_image[data-mimetype^='image'] {
        background-image: url('/static/mimetypes/image.svg');
    }

    .o_image[data-mimetype^='audio'] {
        background-image: url('/static/mimetypes/audio.svg');
    }

    .o_image[data-mimetype^='text'], .o_image[data-mimetype$='rtf'] {
        background-image: url('/static/mimetypes/text.svg');
    }

    .o_image[data-mimetype*='octet-stream'], .o_image[data-mimetype*='download'], .o_image[data-mimetype*='python'] {
        background-image: url('/static/mimetypes/binary.svg');
    }

    .o_image[data-mimetype^='video'], .o_image[title$='.mp4'], .o_image[title$='.avi'] {
        background-image: url('/static/mimetypes/video.svg');
    }

    .o_image[data-mimetype$='archive'], .o_image[data-mimetype$='compressed'], .o_image[data-mimetype*='zip'], .o_image[data-mimetype$='tar'], .o_image[data-mimetype*='package'] {
        background-image: url('/static/mimetypes/archive.svg');
    }

    .o_image[data-mimetype='application/pdf'] {
        background-image: url('/static/mimetypes/pdf.svg');
    }

    .o_image[data-mimetype^='text-master'], .o_image[data-mimetype*='document'], .o_image[data-mimetype*='msword'], .o_image[data-mimetype*='wordprocessing'] {
        background-image: url('/static/mimetypes/document.svg');
    }

    .o_image[data-mimetype*='application/xml'], .o_image[data-mimetype$='html'] {
        background-image: url('/static/mimetypes/web_code.svg');
    }

    .o_image[data-mimetype$='css'], .o_image[data-mimetype$='less'], .o_image[data-ext$='less'] {
        background-image: url('/static/mimetypes/web_style.svg');
    }

    .o_image[data-mimetype*='-image'], .o_image[data-mimetype*='diskimage'], .o_image[data-ext$='dmg'] {
        background-image: url('/static/mimetypes/disk.svg');
    }

    .o_image[data-mimetype$='csv'], .o_image[data-mimetype*='vc'], .o_image[data-mimetype*='excel'], .o_image[data-mimetype$='numbers'], .o_image[data-mimetype$='calc'], .o_image[data-mimetype*='mods'], .o_image[data-mimetype*='spreadsheet'] {
        background-image: url('/static/mimetypes/spreadsheet.svg');
    }

    .o_image[data-mimetype^='key'] {
        background-image: url('/static/mimetypes/certificate.svg');
    }

    .o_image[data-mimetype*='presentation'], .o_image[data-mimetype*='keynote'], .o_image[data-mimetype*='teacher'], .o_image[data-mimetype*='slideshow'], .o_image[data-mimetype*='powerpoint'] {
        background-image: url('/static/mimetypes/presentation.svg');
    }

    .o_image[data-mimetype*='cert'], .o_image[data-mimetype*='rules'], .o_image[data-mimetype*='pkcs'], .o_image[data-mimetype$='stl'], .o_image[data-mimetype$='crl'] {
        background-image: url('/static/mimetypes/certificate.svg');
    }

    .o_image[data-mimetype*='-font'], .o_image[data-mimetype*='font-'], .o_image[data-ext$='ttf'] {
        background-image: url('/static/mimetypes/font.svg');
    }

    .o_image[data-mimetype*='-dvi'] {
        background-image: url('/static/mimetypes/print.svg');
    }

    .o_image[data-mimetype*='script'], .o_image[data-mimetype*='x-sh'], .o_image[data-ext*='bat'], .o_image[data-mimetype$='bat'], .o_image[data-mimetype$='cgi'], .o_image[data-mimetype$='-c'], .o_image[data-mimetype*='java'], .o_image[data-mimetype*='ruby'] {
        background-image: url('/static/mimetypes/script.svg');
    }

    .o_image[data-mimetype*='javascript'] {
        background-image: url('/static/mimetypes/javascript.svg');
    }

    .o_image[data-mimetype*='calendar'], .o_image[data-mimetype$='ldif'] {
        background-image: url('/static/mimetypes/calendar.svg');
    }

    .o_image[data-mimetype$='postscript'], .o_image[data-mimetype$='cdr'], .o_image[data-mimetype$='xara'], .o_image[data-mimetype$='cgm'], .o_image[data-mimetype$='graphics'], .o_image[data-mimetype$='draw'], .o_image[data-mimetype*='svg'] {
        background-image: url('/static/mimetypes/vector.svg');
    }
</style>
